import React from 'react';
import { LineItemDiscrepancyStatusForCreateEditItem } from './LineItemDiscrepancyStatusForCreateEditItem';
import { LineItemDiscrepancyStatusForItemDetails } from './LineItemDiscrepancyStatusForItemDetails';
export const LineItemDiscrepancyStatus = ({ isOnDetailsPage, ...rest }) => {
    return isOnDetailsPage ? (React.createElement(LineItemDiscrepancyStatusForItemDetails, { ...rest })) : (React.createElement(LineItemDiscrepancyStatusForCreateEditItem, { ...rest }));
};
